// extracted by mini-css-extract-plugin
module.exports = {"dropdownContainer":"styles_dropdownContainer__rXW3r","defaultTriggerClassName":"styles_defaultTriggerClassName__J1lX4"};